import React from 'react';
import { MdFilterList } from 'react-icons/md';

import { useTranslations } from 'next-intl';

interface PropTypes {
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
}

const FilterButtonWithIcon: React.FC<PropTypes> = ({ onClick }) => {
  const t = useTranslations();

  return (
    <button
      className="flex flex-row items-center h-[40px] rounded-md bg-white px-4 hover:opacity-[0.5]"
      onClick={onClick}
    >
      <MdFilterList />
      <span className="ml-2 font-bold">
        {t('components.filter_button_with_icon.text')}
      </span>
    </button>
  );
};

export default FilterButtonWithIcon;
